import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noComma'
})
export class NoCommaPipe implements PipeTransform {

  transform(val: number): string {
    if (val !== undefined && val !== null) {
      // here we just remove the commas from value
      //return val.toString().replace(",", " ");
      if(val==0) return "0";
      else {
        let value = val.toString().split(',').join(' ');
        value = value.toString().split('.').join(',');
        // value = value.toString().split(' ').join('.');
        return value//.split('.').join(',');
      }
    } else {
      return "0";
    }
  }
}